<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-l">
        <div class="company-overview">
          <div class="company-logo">
            @if (logoUrl) {
              <img class="company-logo__image" [src]="logoUrl" [alt]="dataContext.name" />
            }
            @if (logoIsBroken) {
              <img class="company-logo__image" src="" alt="Company logo failed to load" />
            }
            @if (!logoUrl && !logoIsBroken) {
              <img class="company-logo__image" src="assets/image/company_logo.png" [alt]="dataContext.name" />
            }
            <div class="company-logo__actions">
              @if (logoUrl || logoIsBroken) {
                <astral-button
                  variant="secondary"
                  size="small"
                  type="button"
                  icon="trash"
                  labelKey="DELETE_BTN"
                  (click)="removeLogo()"
                ></astral-button>
              }
              @if (!logoUrl && !logoIsBroken) {
                <astral-button
                  variant="primary"
                  size="small"
                  type="button"
                  icon="file"
                  labelKey="UPLOAD_BTN"
                  [title]="'COMPANY.LOGO_UPLOAD_BUTTON_TOOLTIP' | translate"
                  (click)="uploadLogo()"
                ></astral-button>
              }
            </div>
            <input class="d-none" type="file" (change)="onChange($event.target.files)" #fileInput />
          </div>
          <div class="company-overview__fields astral-form-stack">
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input [control]="form.controls['number']"></astral-input>
              <astral-input [control]="form.controls['name']"></astral-input>
              <app-contact-id [control]="form.controls['organizationNo']" [idType]="idType"></app-contact-id>
              <astral-input type="email" [control]="form.controls['email']"></astral-input>
              <astral-input type="phone" [control]="form.controls['phone']"></astral-input>
              <astral-input [control]="form.controls['vatNumber']"></astral-input>
              <astral-select [control]="form.controls['cultureName']" [itemsSource]="countries"></astral-select>
              <astral-select [control]="form.controls['currencyCode']" [itemsSource]="currencies"></astral-select>
              <astral-select [control]="form.controls['companyForm']" [itemsSource]="companyForms"></astral-select>
            </astral-layout-group>
            @if (properties.length) {
              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                @for (property of properties; track property) {
                  @if (property.showNumeric || property.showInt) {
                    <astral-input type="number" [control]="property.form.controls['numericValue']"></astral-input>
                  }
                  @if (property.showText) {
                    <astral-input [control]="property.form.controls['textValue']"></astral-input>
                  }
                  @if (property.showBoolean) {
                    <astral-checkbox [control]="property.form.controls['boolValue']"></astral-checkbox>
                  }
                  @if (property.showDate) {
                    <astral-date-picker [control]="property.form.controls['dateValue']"></astral-date-picker>
                  }
                  @if (property.showSelection) {
                    <astral-select [control]="property.form.controls['textValue']" [itemsSource]="property.selection"></astral-select>
                  }
                }
              </astral-layout-group>
            }
            @if (isNew) {
              <astral-toggle [control]="form.controls['amortizationPlanEnabled']"></astral-toggle>
            }
          </div>
        </div>
        <app-address [group]="form.controls['address']" [model]="dataContext.address"></app-address>
      </section>
      <div class="astral-accordion-stack">
        <astral-accordion
          [header]="'COMPANY.INTEGRATION.AMORTIZATION_PLAN_HEADER'"
          [class.d-none]="systemSettings?.externalAccountsReceivable?.enabled"
        >
          <div class="astral-form-stack">
            @if (!isNew) {
              <astral-toggle [control]="form.controls['amortizationPlanEnabled']"></astral-toggle>
            }
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select
                [control]="form.controls['amortizationPlanDefaultArticleId']"
                [itemsSource]="amortizationPlanArticles"
              ></astral-select>
            </astral-layout-group>
            <astral-textarea [control]="form.controls['amortizationPlanLetterText']" [rows]="6"></astral-textarea>
          </div>
        </astral-accordion>
        @if (!isNew) {
          <div class="astral-accordion-stack">
            <astral-accordion [header]="'COMPANY.BANK_ACCOUNT.BANK_ACCOUNTS'">
              <div class="astral-stack-l">
                <app-company-bank-accounts
                  [company]="dataContext"
                  [accountPlanId]="form.controls['accountPlanId'].value"
                  (bankAccountsChanged)="onBankAccountsChanged($event)"
                ></app-company-bank-accounts>
              </div>
            </astral-accordion>
            <astral-accordion [header]="'DASHBOARD.ACCOUNTING_ITEM_HEADER'">
              <div class="astral-stack-l">
                <div class="astral-form-stack">
                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-select
                      [control]="form.controls['firstMonthInAccountingYear']"
                      [itemsSource]="accountYearMonths"
                    ></astral-select>
                    <astral-input
                      [label]="'COMPANY.ACCOUNTING_LOCKED_TO' | translate"
                      [value]="accountingClosedToText"
                      [readonly]="true"
                    ></astral-input>
                    @if (dataContext?.id && (canCloseAccountingPeriod || (canReopenAccountingPeriod && hasClosedAccountingPeriod))) {
                      @if (canCloseAccountingPeriod) {
                        <div class="astral-form-adjacent-action astral-form-adjacent-action--center">
                          <astral-button
                            variant="secondary"
                            type="button"
                            labelKey="ACCOUNTING_PERIOD.CLOSE_BTN"
                            (click)="closeAccountingPeriod()"
                          ></astral-button>
                        </div>
                      }
                      @if (canReopenAccountingPeriod && hasClosedAccountingPeriod) {
                        <div class="astral-form-adjacent-action astral-form-adjacent-action--center">
                          <astral-button
                            variant="secondary"
                            type="button"
                            labelKey="ACCOUNTING_PERIOD.REOPEN_BTN"
                            (click)="reopenAccountingPeriod()"
                          ></astral-button>
                        </div>
                      }
                    }
                  </astral-layout-group>
                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-select
                      [control]="form.controls['closeAccountingAfterDays']"
                      [itemsSource]="closeAfterDaysSelection"
                    ></astral-select>
                    @if (counterPartUsed) {
                      <astral-input [control]="form.controls['counterpart']"></astral-input>
                    }
                  </astral-layout-group>
                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                    @if (isNew) {
                      @if (accountPlanSelection && accountPlanSelection.length > 1) {
                        <astral-select [control]="form.controls['accountPlanId']" [itemsSource]="accountPlanSelection"></astral-select>
                      }
                    } @else {
                      <astral-input
                        [label]="'ACCOUNT_PLAN.ACCOUNT_PLAN' | translate"
                        [value]="currentAccountPlanName"
                        [readonly]="true"
                      ></astral-input>
                    }
                    <astral-input [control]="form.controls['verificationNumberSeriesGeneral']"></astral-input>
                    <astral-input [control]="form.controls['verificationNumberSeriesInvoicing']"></astral-input>
                  </astral-layout-group>
                  @if (!isNew && accountPlanSelection && accountPlanSelection.length > 1) {
                    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                      <div class="astral-form-adjacent-action">
                        <astral-button
                          variant="secondary"
                          type="button"
                          labelKey="COMPANY.ACCOUNT_PLAN.CHANGE"
                          (click)="openAccountPlanSidebar()"
                        ></astral-button>
                      </div>
                    </astral-layout-group>
                  }
                </div>
                <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                  @if (dataContext.useCostPlace) {
                    <section class="astral-section-surface astral-form-stack">
                      @for (group of companyCostPlaces.controls; track group; let i = $index) {
                        <div class="astral-field-action-row">
                          <astral-input [control]="$any(group).controls['costPlace']"></astral-input>
                          <div class="astral-form-adjacent-action">
                            <astral-button
                              variant="secondary"
                              size="small"
                              type="button"
                              icon="trash"
                              labelKey="DELETE_BTN"
                              (click)="removeCostPlace(i)"
                            ></astral-button>
                          </div>
                        </div>
                      }
                      <astral-button
                        variant="primary"
                        size="small"
                        type="button"
                        icon="plus"
                        [label]="addCostPlaceButtonText"
                        [title]="addCostPlaceHelpText"
                        (click)="addCostPlace()"
                      ></astral-button>
                    </section>
                  }
                  @if (dataContext.useCostBearer) {
                    <section class="astral-section-surface astral-form-stack">
                      @for (group of companyCostBearers.controls; track group; let i = $index) {
                        <div class="astral-field-action-row">
                          <astral-input [control]="$any(group).controls['costBearer']"></astral-input>
                          <div class="astral-form-adjacent-action">
                            <astral-button
                              variant="secondary"
                              size="small"
                              type="button"
                              icon="trash"
                              ariaLabel="DELETE_BTN"
                              (click)="removeCostBearer(i)"
                            ></astral-button>
                          </div>
                        </div>
                      }
                      <astral-button
                        variant="primary"
                        size="small"
                        type="button"
                        icon="plus"
                        [label]="addCostBearerButtonText"
                        [title]="addCostBearerHelpText"
                        (click)="addCostBearer()"
                      ></astral-button>
                    </section>
                  }
                </astral-layout-group>
                @if (!isNew) {
                  <div>
                    <hr />
                    @if (!accountingConnectionInProgress) {
                      <section class="astral-stack-l">
                        <h4>{{ 'COMPANY.ACC_TRANSFER.SELECTION_HEADER' | translate }}</h4>
                        @if (showAccountingTransferOptions) {
                          <astral-tabs
                            appearance="tinted"
                            [tabs]="accountingTabs"
                            [selectedId]="selectedAccountingTabId"
                            (selectedIdChange)="onAccountingTabChange($event)"
                            panelId="company-accounting-tab-panel"
                            tabIdPrefix="company-accounting-tab"
                          ></astral-tabs>
                          <div
                            id="company-accounting-tab-panel"
                            role="tabpanel"
                            [attr.aria-labelledby]="'company-accounting-tab-' + selectedAccountingTabId"
                          >
                            <div [hidden]="selectedAccountingTabId !== 'manual'">
                              <app-information-block [text]="'COMPANY.ACC_TRANSFER.MANUAL_DESCRIPTION' | translate"></app-information-block>
                            </div>
                            <div [hidden]="selectedAccountingTabId !== accountingTabKeyHogia">
                              @if (hogiaEnabledOnLoad) {
                                <div class="astral-stack-l">
                                  <div class="partner-info">
                                    <div class="partner-logo"></div>
                                    <span>{{ hogiaAccountingText }}</span>
                                  </div>
                                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [alignItems]="'center'">
                                    <astral-input [control]="form.controls['hogiaOpenBusinessApiKey']"></astral-input>
                                    <div class="astral-form-adjacent-action">
                                      <astral-button
                                        variant="primary"
                                        type="button"
                                        labelKey="HOGIA.SEND"
                                        (click)="sendAccountingToProvider()"
                                        [disabled]="isConnectToHogiaObDisabled"
                                      ></astral-button>
                                    </div>
                                    <div class="astral-form-adjacent-action">
                                      <astral-button
                                        variant="primary"
                                        type="button"
                                        labelKey="HOGIA.DISCONNECT"
                                        (click)="disconnectAccounting()"
                                      ></astral-button>
                                    </div>
                                    <astral-checkbox [control]="form.controls['hogiaObBundleVouchers']"></astral-checkbox>
                                    <astral-checkbox [control]="form.controls['hogiaObAsymmetricBundling']"></astral-checkbox>
                                  </astral-layout-group>
                                </div>
                              }
                              @if (!hogiaEnabledOnLoad) {
                                <div class="astral-stack-l">
                                  <div class="partner-info">
                                    <img src="../../../../assets/image/Hogia-logo.png" alt="Hogia logo" class="partner-logo" />
                                    <span>{{ hogiaEnableAccountingText }}</span>
                                  </div>
                                  <app-radio-group
                                    [control]="form.controls['accountingChoiceHogia']"
                                    [items]="accountingChoicesHogia"
                                  ></app-radio-group>
                                  <div class="astral-action-with-help">
                                    <astral-button
                                      variant="primary"
                                      type="button"
                                      labelKey="HOGIA.CONNECT"
                                      (click)="connectHogia()"
                                      [disabled]="isConnectToHogiaObDisabled"
                                    ></astral-button>
                                    <astral-popover [helpText]="'HOGIA.HELP_TEXT.REQUIRMENT'"></astral-popover>
                                  </div>
                                </div>
                              }
                            </div>
                            <div [hidden]="selectedAccountingTabId !== 'fortnox'">
                              @if (!fortnoxEnabledOnLoad) {
                                <div class="astral-stack-l">
                                  <div class="partner-info">
                                    <img src="../../../../assets/image/fortnox.png" alt="Fortnox logo" class="partner-logo" />
                                    <span>{{ 'FORTNOX.CONNECT_INFO' | translate }}</span>
                                  </div>
                                  <astral-button
                                    variant="primary"
                                    type="button"
                                    labelKey="FORTNOX.CONNECT"
                                    (click)="connectFortnox()"
                                  ></astral-button>
                                </div>
                              }
                            </div>
                            <div [hidden]="selectedAccountingTabId !== 'visma'">
                              @if (!vismaEnabledOnLoad) {
                                <div class="astral-stack-l">
                                  <div class="partner-info">
                                    <img src="../../../../assets/image/visma.svg" alt="Visma logo" class="partner-logo" />
                                    <span>{{ vismaEnableAccountingText }}</span>
                                  </div>
                                  <app-radio-group
                                    [control]="form.controls['accountingChoiceVisma']"
                                    [items]="accountingChoicesVisma"
                                  ></app-radio-group>
                                  <astral-button
                                    variant="primary"
                                    type="button"
                                    [label]="vismaConnectButtonText"
                                    (click)="connectVisma()"
                                  ></astral-button>
                                </div>
                              }
                            </div>
                            <div [hidden]="selectedAccountingTabId !== accountingTabKeySftp">
                              <div class="astral-stack-l">
                                <h5>{{ 'COMPANY.SETTINGS_SFTP' | translate }}</h5>
                                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                                  <astral-select
                                    [control]="form.controls['ftpTimeOfDay']"
                                    [itemsSource]="accountingTransferTimeIntervals"
                                  ></astral-select>
                                  <astral-select
                                    [control]="form.controls['ftpProtocol']"
                                    [itemsSource]="ftpProtocols"
                                    [helpText]="'COMPANY.HELP_TEXT.FTP_PROTOCOL'"
                                  ></astral-select>
                                  <astral-input
                                    [control]="form.controls['ftpAddress']"
                                    [helpText]="'COMPANY.HELP_TEXT.FTP_ADDRESS'"
                                  ></astral-input>
                                  <astral-input
                                    type="number"
                                    [control]="form.controls['ftpPort']"
                                    [helpText]="'COMPANY.HELP_TEXT.FTP_PORT'"
                                  ></astral-input>
                                  <astral-input
                                    [control]="form.controls['ftpUser']"
                                    [helpText]="'COMPANY.HELP_TEXT.FTP_USER'"
                                  ></astral-input>
                                  <astral-input
                                    type="password"
                                    [control]="form.controls['ftpPassword']"
                                    [helpText]="'COMPANY.HELP_TEXT.FTP_PASSWORD'"
                                  ></astral-input>
                                  <astral-input
                                    [control]="form.controls['ftpPath']"
                                    [helpText]="'COMPANY.HELP_TEXT.FTP_PATH'"
                                  ></astral-input>
                                </astral-layout-group>
                                <app-information-block [text]="'COMPANY.FTP_SENDER_IP_INFO' | translate"></app-information-block>
                                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                                  <astral-select [control]="form.controls['ftpFileFormat']" [itemsSource]="ftpFileFormats"></astral-select>
                                  @if (form.controls['ftpFileFormat'].value == 0) {
                                    <astral-select
                                      [control]="form.controls['ftpFileNamingConvention']"
                                      [itemsSource]="ftpFileNameConventionSelection"
                                    ></astral-select>
                                  }
                                  <astral-input [control]="form.controls['ftpFilePrefix']"></astral-input>
                                </astral-layout-group>
                                @if (form.controls['ftpFileFormat'].value == 1) {
                                  <div>
                                    <app-company-gl07-config
                                      [dataContext]="dataContext.gl07ExportConfiguration"
                                      [form]="form.controls['gl07ExportConfiguration']"
                                      [dimensionSelection]="gl07DimensionSelection"
                                      [customerOrSupplierIdDimSelection]="customerOrSupplierIdDimSelection"
                                    ></app-company-gl07-config>
                                  </div>
                                }
                                @if (form.controls['ftpFileFormat'].value == 2) {
                                  <div>
                                    <app-company-raindance-config
                                      [dataContext]="dataContext.raindanceExportConfiguration"
                                      [form]="form.controls['raindanceExportConfiguration']"
                                      [dimensionSelection]="gl07DimensionSelection"
                                    ></app-company-raindance-config>
                                  </div>
                                }
                                @if (form.controls['ftpFileFormat'].value == 3) {
                                  <div>
                                    <app-company-visma-ror-config
                                      [dataContext]="dataContext.vismaRorExportConfiguration"
                                      [form]="form.controls['vismaRorExportConfiguration']"
                                    ></app-company-visma-ror-config>
                                  </div>
                                }
                                @if (form.controls['ftpFileFormat'].value == 1) {
                                  <div>
                                    <div class="astral-action-with-help">
                                      <astral-button
                                        variant="primary"
                                        type="button"
                                        labelKey="COMPANY.ACC_TRANSFER.DOWNLOAD_GL07_BUTTON"
                                        (click)="downloadGl07()"
                                      ></astral-button>
                                      <astral-popover [helpText]="'COMPANY.ACC_TRANSFER.HELP_TEXT.DOWNLOAD_GL07_BUTTON'"></astral-popover>
                                    </div>
                                  </div>
                                }
                                @if (form.controls['ftpFileFormat'].value == 2) {
                                  <div>
                                    <div class="astral-action-with-help">
                                      <astral-button
                                        variant="primary"
                                        type="button"
                                        labelKey="COMPANY.ACC_TRANSFER.DOWNLOAD_RAINDANCE_BUTTON"
                                        (click)="downloadRaindance()"
                                      ></astral-button>
                                      <astral-popover
                                        [helpText]="'COMPANY.ACC_TRANSFER.HELP_TEXT.DOWNLOAD_RAINDANCE_BUTTON'"
                                      ></astral-popover>
                                    </div>
                                  </div>
                                }
                                @if (form.controls['ftpFileFormat'].value == 3) {
                                  <div>
                                    <div class="astral-action-with-help">
                                      <astral-button
                                        variant="primary"
                                        type="button"
                                        labelKey="COMPANY.ACC_TRANSFER.DOWNLOAD_VISMA_ROR_BUTTON"
                                        (click)="downloadVismaRor()"
                                      ></astral-button>
                                      <astral-popover [helpText]="'COMPANY.ACC_TRANSFER.HELP_TEXT.DOWNLOAD_VISMA_ROR_BUTTON'"></astral-popover>
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                            <div [hidden]="selectedAccountingTabId !== accountingTabKeyEmail || !emailTransferForm">
                              <div class="astral-stack-l">
                                <h5>{{ 'COMPANY.SETTINGS_EMAIL' | translate }}</h5>
                                <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                                  <astral-input type="email" [control]="emailTransferForm.controls['emailAddress']"></astral-input>
                                  <astral-select
                                    [control]="emailTransferForm.controls['dayOfMonth']"
                                    [itemsSource]="sendAccountingDaySelection"
                                  ></astral-select>
                                </astral-layout-group>
                              </div>
                            </div>
                          </div>
                        }
                        @if (fortnoxEnabledOnLoad) {
                          <div class="astral-stack-l">
                            <div class="partner-info">
                              <div class="partner-logo"></div>
                              <span>{{ 'FORTNOX.CONNECTED_INFO' | translate }}</span>
                            </div>
                            <div class="astral-form-actions">
                              <astral-button
                                variant="primary"
                                type="button"
                                labelKey="FORTNOX.SEND"
                                (click)="sendAccountingToProvider()"
                              ></astral-button>
                              <astral-button
                                variant="primary"
                                type="button"
                                labelKey="FORTNOX.DISCONNECT"
                                (click)="disconnectAccounting()"
                              ></astral-button>
                            </div>
                          </div>
                        }
                        @if (vismaEnabledOnLoad) {
                          <div class="astral-stack-l">
                            <div class="partner-info">
                              <div class="partner-logo"></div>
                              <span>{{ vismaAccountingText }}</span>
                            </div>
                            @if (!vismaOnlineSelected) {
                              <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                                <astral-input [control]="form.controls['vismaControlEdgeTenantId']"></astral-input>
                                <astral-input [control]="form.controls['vismaControlEdgeStorageSpaceId']"></astral-input>
                                <astral-input [control]="form.controls['vismaControlEdgeBusinessUnitName']"></astral-input>
                                <astral-select
                                  [control]="form.controls['vismaControlEdgeO1']"
                                  [itemsSource]="dimensionSelection"
                                ></astral-select>
                                <astral-select
                                  [control]="form.controls['vismaControlEdgeO2']"
                                  [itemsSource]="dimensionSelection"
                                ></astral-select>
                                <astral-select
                                  [control]="form.controls['vismaControlEdgeO3']"
                                  [itemsSource]="dimensionSelection"
                                ></astral-select>
                              </astral-layout-group>
                            }
                            <div class="astral-form-actions">
                              <astral-button
                                variant="primary"
                                type="button"
                                labelKey="FORTNOX.SEND"
                                (click)="sendAccountingToProvider()"
                              ></astral-button>
                              <astral-button
                                variant="primary"
                                type="button"
                                labelKey="FORTNOX.DISCONNECT"
                                (click)="disconnectAccounting()"
                              ></astral-button>
                            </div>
                          </div>
                        }
                        @if (!manualAccountingTransfer) {
                          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                            <astral-input inputMode="email" [control]="form.controls['accountingExportErrorEmailAddress']"></astral-input>
                            <astral-date-picker [control]="form.controls['firstAccountingDateToExport']"></astral-date-picker>
                            <astral-select
                              [control]="form.controls['accountingExportDateLimit']"
                              [itemsSource]="accountingToSelection"
                            ></astral-select>
                          </astral-layout-group>
                        }
                        <app-company-sie-config
                          [dataContext]="dataContext.sie4ExportConfiguration"
                          [form]="form.controls['sie4ExportConfiguration']"
                          [dimensionSelection]="dimensionSelection"
                        ></app-company-sie-config>
                      </section>
                    }
                  </div>
                }
              </div>
            </astral-accordion>
            @if (showBrf) {
              <astral-accordion [header]="'RENTAL_OBJECT.FORMS_OF_LEASE.COOPERATIVE_HOUSING'">
                <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-date-picker
                    [control]="form.controls['economicalPlanSent']"
                    [model]="dataContext.economicalPlanSent"
                    [label]="'COOPERATIVE_HOUSING.ECONOMICAL_PLAN_CREATED'"
                  ></astral-date-picker>
                  <astral-date-picker
                    [control]="form.controls['economicalPlanApproved']"
                    [model]="dataContext.economicalPlanApproved"
                    [label]="'COOPERATIVE_HOUSING.ECONOMICAL_PLAN_APPROVED'"
                  ></astral-date-picker>
                </astral-layout-group>
              </astral-accordion>
            }
            <astral-accordion [header]="'LEASE_AGREEMENT.INVOICING_HEADER'">
              <div class="astral-stack-l">
                <div class="astral-stack-l">
                <section class="astral-section-surface astral-stack-m">
                  <div class="astral-form-stack">
                    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-select
                        [control]="form.controls['invoicingBankAccountId']"
                        [itemsSource]="bankAccountSelection"
                      ></astral-select>
                      <astral-input [control]="form.controls['paymentReceiver']"></astral-input>
                      <astral-input [control]="form.controls['nextInvoiceNumber']"></astral-input>
                    </astral-layout-group>
                    <astral-textarea [control]="form.controls['invoiceFooter']"></astral-textarea>
                  </div>
                </section>
                @if (!isNew && systemSettings) {
                  <section class="astral-section-surface astral-stack-m">
                    <h3 class="astral-section-heading">{{ 'COMPANY.EXTERNAL_ACCOUNTS_RECEIVABLE.TITLE' | translate }}</h3>
                    <app-information-block [text]="'COMPANY.EXTERNAL_ACCOUNTS_RECEIVABLE.DESCRIPTION' | translate"></app-information-block>
                    <div class="astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                      <astral-input
                        [label]="'COMPANY.EXTERNAL_ACCOUNTS_RECEIVABLE.TITLE' | translate"
                        [value]="getEnabledText(systemSettings.externalAccountsReceivable.enabled)"
                        [readonly]="true"
                      ></astral-input>
                      <div class="astral-form-actions astral-form-actions--start">
                        <astral-button
                          variant="secondary"
                          type="button"
                          labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                          (click)="openSystemSettingsSidebar('externalAccountsReceivable')"
                        ></astral-button>
                      </div>
                    </div>
                  </section>
                }
                </div>

              <div class="astral-stack-l" [class.d-none]="systemSettings?.externalAccountsReceivable?.enabled">
                @if (!isNew && systemSettings) {
                  <section class="astral-section-surface astral-stack-m">
                    <h3 class="astral-section-heading">{{ 'COMPANY.SYSTEM_SETTINGS_BULK.TARGET.INVOICE_REMINDER' | translate }}</h3>
                    <div class="astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                        <astral-input
                          [label]="'COMPANY.SYSTEM_SETTINGS_BULK.TARGET.INVOICE_REMINDER' | translate"
                          [value]="getEnabledText(systemSettings.invoiceReminder.enabled)"
                          [readonly]="true"
                        ></astral-input>
                        @if (systemSettings.invoiceReminder.enabled) {
                          <astral-input
                            [label]="'COMPANY.SYSTEM_SETTINGS_BULK.FIELD.REMIND_AFTER_DAYS' | translate"
                            [value]="systemSettings.invoiceReminder.remindAfterDays"
                            [readonly]="true"
                          ></astral-input>
                        }
                        @for (field of systemSettings.invoiceReminder.enabled ? reminderDeliveryMethodFields : []; track field) {
                          <astral-input
                            [label]="field.caption"
                            [value]="getSelectionText(reminderDeliveryMethodSelection, getInvoiceReminderDeliveryMethod(field.property))"
                            [readonly]="true"
                          ></astral-input>
                        }
                      </astral-layout-group>
                      <div class="astral-form-actions astral-form-actions--start">
                        <astral-button
                          variant="secondary"
                          type="button"
                          labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                          (click)="openSystemSettingsSidebar('invoiceReminder')"
                        ></astral-button>
                      </div>
                    </div>
                  </section>
                  <section class="astral-section-surface astral-stack-m">
                    <h3 class="astral-section-heading">{{ 'COMPANY.SYSTEM_SETTINGS_BULK.TARGET.AUTOMATIC_ADVICING' | translate }}</h3>
                    <div class="astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                        <astral-input
                          [label]="'COMPANY.SYSTEM_SETTINGS_BULK.TARGET.AUTOMATIC_ADVICING' | translate"
                          [value]="getEnabledText(systemSettings.automaticAdvicing.enabled)"
                          [readonly]="true"
                        ></astral-input>
                        @if (systemSettings.automaticAdvicing.enabled) {
                          <astral-input
                            [label]="'COMPANY.SYSTEM_SETTINGS_BULK.FIELD.AUTOMATIC_ADVICING_DAY' | translate"
                            [value]="systemSettings.automaticAdvicing.automaticAdvicingDayInMonth"
                            [readonly]="true"
                          ></astral-input>
                        }
                      </astral-layout-group>
                      <div class="astral-form-actions astral-form-actions--start">
                        <astral-button
                          variant="secondary"
                          type="button"
                          labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                          (click)="openSystemSettingsSidebar('automaticAdvicing')"
                        ></astral-button>
                      </div>
                    </div>
                  </section>
                }
                <section class="astral-section-surface astral-form-stack">
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
                    <astral-toggle [control]="form.controls['eInvoiceSpecified']"></astral-toggle>
                    @if (eInvoice) {
                      <astral-input [control]="form.controls['eInvoiceAddress']"></astral-input>
                    }
                  </astral-layout-group>
                </section>
                @if (hasKivraLicense) {
                  <div class="astral-section-surface astral-stack-m">
                    <p>
                      {{ 'TENANT.KIVRA_AGREEMENT_ACCEPT' | translate }}
                      <a
                        href="https://kivra.se/sv/om-oss/om-kivra/villkor/allmanna-villkor-for-formedlingstjansten"
                        target="_blank"
                        (click)="$event.stopPropagation()"
                      >
                        {{ 'TENANT.KIVRA_AGREEMENT' | translate }}
                      </a>
                    </p>
                    <astral-toggle [control]="form.controls['isKivraIntegrationEnabled']"></astral-toggle>
                  </div>
                }
                <section class="astral-section-surface astral-form-stack">
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-select [control]="form.controls['articleId']" [itemsSource]="articles"></astral-select>
                    <astral-select [control]="form.controls['invoicingInterval']" [itemsSource]="invoicingIntervals"></astral-select>
                    @if (showImdOffset) {
                      <astral-select [control]="form.controls['imdOffset']" [itemsSource]="imdOffsetSelection"></astral-select>
                    }
                  </astral-layout-group>
                </section>
                <section class="astral-section-surface astral-form-stack">
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-select [control]="form.controls['invoiceFeeArticleId_Mail']" [itemsSource]="invoiceFeeArticles"></astral-select>
                    @if (form.controls['invoiceFeeArticleId_Mail'].value) {
                      <div>
                        <app-money-box [control]="form.controls['invoiceFeeAmount_Mail']"></app-money-box>
                      </div>
                    }
                  </astral-layout-group>
                  @if (showKivraInvoiceFee) {
                    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-select
                        [control]="form.controls['invoiceFeeArticleId_Kivra']"
                        [itemsSource]="invoiceFeeArticles"
                      ></astral-select>
                      @if (form.controls['invoiceFeeArticleId_Kivra'].value) {
                        <div>
                          <app-money-box [control]="form.controls['invoiceFeeAmount_Kivra']"></app-money-box>
                        </div>
                      }
                    </astral-layout-group>
                  }
                  @if (showB2cInvoiceFee) {
                    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-select
                        [control]="form.controls['invoiceFeeArticleId_B2CeInvoice']"
                        [itemsSource]="invoiceFeeArticles"
                      ></astral-select>
                      @if (form.controls['invoiceFeeArticleId_B2CeInvoice'].value) {
                        <div>
                          <app-money-box [control]="form.controls['invoiceFeeAmount_B2CeInvoice']"></app-money-box>
                        </div>
                      }
                    </astral-layout-group>
                  }
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-select
                      [control]="form.controls['invoiceFeeArticleId_B2BeInvoice']"
                      [itemsSource]="invoiceFeeArticles"
                    ></astral-select>
                    @if (form.controls['invoiceFeeArticleId_B2BeInvoice'].value) {
                      <div>
                        <app-money-box [control]="form.controls['invoiceFeeAmount_B2BeInvoice']"></app-money-box>
                      </div>
                    }
                  </astral-layout-group>
                </section>
                <section class="astral-section-surface">
                  <app-text-box-readonly
                    [caption]="'B2C_SUBS.ISSUER_IDENTITY'"
                    [text]="dataContext.issuerIdentity"
                    [helpText]="'COMPANY.HELP_TEXT.ISSUER_IDENTITY'"
                  ></app-text-box-readonly>
                </section>
              </div>
              </div>
            </astral-accordion>
            <astral-accordion
              [header]="'COMPANY.DEBT_COLLECTION.DEBT_COLLECTION'"
              [class.d-none]="systemSettings?.externalAccountsReceivable?.enabled"
            >
              <div class="astral-stack-l">
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-select
                    [control]="debtCollectionForm.controls['debtCollectionSupplier']"
                    [itemsSource]="debtCollectionSupplierKinds"
                  ></astral-select>
                </astral-layout-group>
                @if (showDebtCollectionRopo) {
                  <app-information-block
                    [text]="'COMPANY.DEBT_COLLECTION.ROPO_CAPITAL_API_DESCRIPTION' | translate"
                  ></app-information-block>
                }
                @if (showDebtCollectionRopo) {
                  <app-select-slider
                    [options]="debtCollectionCaseTransferOptions"
                    [control]="debtCollectionCaseTransfer"
                  ></app-select-slider>
                }
                @if (showDebtCollectionRopo) {
                  <div>
                    @if (showRopo) {
                      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                        <astral-input [control]="debtCollectionForm.controls['userName']"></astral-input>
                        <astral-input type="password" [control]="debtCollectionForm.controls['password']"></astral-input>
                        <astral-input [control]="debtCollectionForm.controls['client']"></astral-input>
                        <astral-input [control]="debtCollectionForm.controls['division']"></astral-input>
                      </astral-layout-group>
                    }
                    @if (showRopoOne) {
                      <div class="astral-stack-m">
                        <app-information-block
                          [text]="'COMPANY.DEBT_COLLECTION.ROPO_CAPITAL_API_REQUIREMENT' | translate"
                        ></app-information-block>
                        <astral-button
                          variant="primary"
                          type="button"
                          labelKey="COMPANY.DEBT_COLLECTION.ROPOONE_SEND"
                          (click)="sendDebtCollection()"
                          [disabled]="isSendDebtCollectionDisabled"
                          [title]="'COMPANY.HELP_TEXT.DEBT_COLLECTION.ROPOONE_TOOLTIP_SEND_BTN' | translate"
                        ></astral-button>
                      </div>
                    }
                  </div>
                }
              </div>
            </astral-accordion>
            @if (!isNew) {
              <astral-accordion [header]="'DASHBOARD.DWELLING_INSPECTION_ITEM_HEADER'">
                <div class="astral-form-stack">
                  <astral-toggle [control]="form.controls['onlineTerminationDwellingInspection']"></astral-toggle>
                  @if (form.controls['onlineTerminationDwellingInspection'].value) {
                    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-select
                        [control]="form.controls['dwellingInspectionTypeMainId']"
                        [itemsSource]="dwellingInspectionTypesSelection"
                      ></astral-select>
                      <astral-select
                        [control]="form.controls['dwellingInspectionTypeOptionalId']"
                        [itemsSource]="dwellingInspectionTypesSelection"
                      ></astral-select>
                    </astral-layout-group>
                  }
                </div>
              </astral-accordion>
            }
            <astral-accordion [header]="'COMPANY.SYSTEM_SETTINGS.ERRANDS_HEADER'">
              <div class="astral-stack-l">
                @if (!isNew && systemSettings) {
                  <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-input
                        [label]="'COMPANY.SYSTEM_SETTINGS_BULK.TARGET.FAULT_NOTIFICATION' | translate"
                        [value]="getEnabledText(systemSettings.faultNotification.enabled)"
                        [readonly]="true"
                      ></astral-input>
                      @if (systemSettings.faultNotification.enabled) {
                        <astral-input
                          [label]="'COMPANY.SYSTEM_SETTINGS_BULK.FIELD.SEND_LANDLORD_NOTIFICATION' | translate"
                          [value]="getYesNoText(systemSettings.faultNotification.sendLandlordNotification)"
                          [readonly]="true"
                        ></astral-input>
                      }
                      @if (systemSettings.faultNotification.enabled && systemSettings.faultNotification.sendLandlordNotification) {
                        <astral-input
                          [label]="'COMPANY.SYSTEM_SETTINGS_BULK.FIELD.FAULT_NOTIFICATION_RECEIVERS' | translate"
                          [value]="getFaultNotificationReceiversText()"
                          [readonly]="true"
                        ></astral-input>
                      }
                    </astral-layout-group>
                    <div class="astral-form-actions astral-form-actions--start">
                      <astral-button
                        variant="secondary"
                        type="button"
                        labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                        (click)="openSystemSettingsSidebar('faultNotification')"
                      ></astral-button>
                    </div>
                  </section>
                }
                @if (systemSettings?.faultNotification?.enabled) {
                  <section class="astral-section-surface astral-stack-m">
                    <div class="astral-form-stack astral-form-stack--relaxed">
                      <app-information-block
                        mode="compact"
                        [text]="'COMPANY.INFORMATION_BLOCKS.FN_ACTIVATE_MESSAGES' | translate"
                      ></app-information-block>
                      <astral-toggle [control]="form.controls['enableFaultNotificationDialog']"></astral-toggle>
                    </div>
                    <div class="astral-form-stack astral-form-stack--relaxed">
                      <app-information-block
                        mode="compact"
                        [text]="'COMPANY.INFORMATION_BLOCKS.FN_ACTIVATE_REPORTING' | translate"
                      ></app-information-block>
                      <astral-toggle [control]="form.controls['enableFaultNotificationReporting']"></astral-toggle>
                    </div>
                  </section>
                }
              </div>
            </astral-accordion>
            @if (!isNew) {
              <astral-accordion [header]="'CONSUMPTION.CONSUMPTION'">
                <div class="astral-stack-l">
                  <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
                    <astral-toggle [control]="form.controls['imdFtpEnabled']"></astral-toggle>
                    @if (showImdFtp) {
                      <astral-toggle [control]="form.controls['imdFtpChargeNegativeValues']"></astral-toggle>
                    }
                  </astral-layout-group>
                  @if (showImdFtp) {
                    <div class="astral-stack-m">
                      <p>{{ 'COMPANY.IMD_FTP_DESCRIPTION' | translate }}</p>
                      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                        <astral-input [control]="form.controls['imdFtpAddress']"></astral-input>
                        <astral-input [control]="form.controls['imdFtpPort']"></astral-input>
                        <astral-input [control]="form.controls['imdFtpUser']"></astral-input>
                        <astral-input
                          type="password"
                          [allowPasswordReveal]="false"
                          autocomplete="new-password"
                          inputName="imd-ftp-password"
                          [control]="form.controls['imdFtpPassword']"
                        ></astral-input>
                      </astral-layout-group>
                    </div>
                  }
                </div>
              </astral-accordion>
            }
            @if (!isNew) {
              <astral-accordion [header]="'COMPANY.INTEGRATION.TENANT_APPS_HEADER'">
                <div class="astral-stack-l">
                  <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-input
                        [label]="'COMPANY.INTEGRATION.AVY_TENANT_APP' | translate"
                        [value]="avyIntegrationStatusKey | translate"
                        [readonly]="true"
                      ></astral-input>
                    </astral-layout-group>
                    <div class="astral-form-actions astral-form-actions--start">
                      <astral-button
                        variant="secondary"
                        type="button"
                        labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                        (click)="openAvyIntegrationSidebar()"
                      ></astral-button>
                    </div>
                  </section>
                </div>
              </astral-accordion>
            }
            @if (!isNew) {
              <astral-accordion [header]="'COMPANY.INTEGRATION.INFO_BOARD_HEADER'">
                <div class="astral-form-stack">
                  <astral-toggle [control]="form.controls['dinBoxEnabled']"></astral-toggle>
                  @if (form.controls['dinBoxEnabled'].value) {
                    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-input [control]="form.controls['dinBoxUserName']"></astral-input>
                      <astral-input type="password" [control]="form.controls['dinBoxPassword']"></astral-input>
                    </astral-layout-group>
                  }
                  <astral-toggle [control]="form.controls['nameplateEnabled']"></astral-toggle>
                  @if (form.controls['nameplateEnabled'].value) {
                    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
                      <astral-toggle [control]="form.controls['nameplateOneline']"></astral-toggle>
                      <astral-toggle [control]="form.controls['nameplateShortNames']"></astral-toggle>
                    </astral-layout-group>
                  }
                  @if (form.controls['nameplateEnabled'].value) {
                    <astral-textarea [control]="form.controls['defaultNameplate']" [rows]="2" [nameplate]="true"></astral-textarea>
                  }
                </div>
              </astral-accordion>
            }
            <astral-accordion
              [header]="'COMPANY.TEMPLATE_VALUES_NEW_LEASEAGREEMENT'"
              [helpText]="'COMPANY.HELP_TEXT.TEMPLATE_VALUES_NEW_LEASEAGREEMENT'"
            >
              <div class="astral-form-stack">
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-select [control]="form.controls['useEarlyTermination']" [itemsSource]="useEarlyTerminations"></astral-select>
                </astral-layout-group>
                <astral-textarea [control]="form.controls['generalTermsDwelling']" [rows]="5"></astral-textarea>
                <astral-textarea [control]="form.controls['generalTermsParking']" [rows]="5"></astral-textarea>
                <astral-textarea [control]="form.controls['specialTermsDwelling']" [rows]="5"></astral-textarea>
                <astral-textarea [control]="form.controls['specialTermsParking']" [rows]="5"></astral-textarea>
                <astral-textarea [control]="form.controls['rentPaymentTermsDwelling']" [rows]="5"></astral-textarea>
                <astral-textarea [control]="form.controls['rentPaymentTermsParking']" [rows]="5"></astral-textarea>
              </div>
            </astral-accordion>
            @if (!isNew && systemSettings) {
              <astral-accordion [header]="'TERMINATE_LEASE_AGREEMENT_FORM.HEADER'">
                <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-input
                      [label]="'COMPANY.SYSTEM_SETTINGS.TERMINATION.USE_DIGITAL_SIGNING_WHEN_TENANT_TERMINATES' | translate"
                      [value]="getYesNoText(systemSettings.termination.useDigitalSigningWhenTerminatedByTenant)"
                      [readonly]="true"
                    ></astral-input>
                    <astral-input
                      [label]="'COMPANY.SYSTEM_SETTINGS.TERMINATION.USE_DIGITAL_SIGNING_WHEN_LANDLORD_TERMINATES' | translate"
                      [value]="getYesNoText(systemSettings.termination.useDigitalSigningWhenTerminatedByLandlord)"
                      [readonly]="true"
                    ></astral-input>
                    <astral-input
                      [label]="'COMPANY.SYSTEM_SETTINGS.TERMINATION.REQUIRE_SIGNATURE_BEFORE_LANDLORD_TERMINATION_COMPLETES' | translate"
                      [value]="getYesNoText(systemSettings.termination.requireSignatureBeforeTerminationWhenLandlordUsesDigitalSigning)"
                      [readonly]="true"
                    ></astral-input>
                    <astral-input
                      class="astral-grid-full"
                      [label]="'TERMINATE_LEASE_AGREEMENT_FORM.LANDLORD_MESSAGE' | translate"
                      [value]="systemSettings.termination.landlordMessage"
                      [readonly]="true"
                    ></astral-input>
                  </astral-layout-group>
                  <div class="astral-form-actions astral-form-actions--start">
                    <astral-button
                      variant="secondary"
                      type="button"
                      labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                      (click)="openSystemSettingsSidebar('termination')"
                    ></astral-button>
                  </div>
                </section>
              </astral-accordion>
            }
            @if (!isNew && systemSettings) {
              <astral-accordion header="Hyra">
                <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                  <app-information-block
                    mode="compact"
                    [text]="'COMPANY.SYSTEM_SETTINGS.HELP_TEXT.PERIOD_RENT_ROUNDING'"
                  ></app-information-block>
                  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-input
                      [label]="'LEASE_AGREEMENT.RENTAL_CHANGES_ROUND_PERIOD_RENT' | translate"
                      [value]="getYesNoText(systemSettings.rent.roundPeriodRent)"
                      [readonly]="true"
                    ></astral-input>
                  </astral-layout-group>
                  <div class="astral-form-actions astral-form-actions--start">
                    <astral-button
                      variant="secondary"
                      type="button"
                      labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                      (click)="openSystemSettingsSidebar('rent')"
                    ></astral-button>
                  </div>
                </section>
              </astral-accordion>
            }
            @if (!isNew && systemSettings) {
              <astral-accordion [header]="'PROFILE_SETTINGS_FORM.TENANT_PAGES'">
                <div class="astral-stack-m">
                  <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-input
                        [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_LABEL' | translate"
                        [value]="getEnabledText(systemSettings.tenantPages.enabled)"
                        [readonly]="true"
                      ></astral-input>
                      @if (systemSettings.tenantPages.enabled) {
                        <astral-input
                          [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_SOURCE' | translate"
                          [value]="getTenantPageSourceText(systemSettings.tenantPages.tenantPageSource)"
                          [readonly]="true"
                        ></astral-input>
                        @if (showReadonlyExternalTenantPageSettings) {
                          <astral-input
                            [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_EXTERNAL_URL' | translate"
                            [value]="systemSettings.tenantPages.tenantPageExternalUrl"
                            [readonly]="true"
                          ></astral-input>
                        }
                        <astral-input
                          [label]="'PROFILE_SETTINGS_FORM.DISPLAY_DWELLING_INSPECTION' | translate"
                          [value]="getYesNoText(systemSettings.tenantPages.displayDwellingInspection)"
                          [readonly]="true"
                          [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.DISPLAY_DWELLING_INSPECTION'"
                        ></astral-input>
                      }
                    </astral-layout-group>
                  </section>
                  @if (showReadonlyBuiltInTenantPageSettings) {
                    <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                      <h3 class="astral-section-heading">{{ 'COMPANY.SYSTEM_SETTINGS.TENANT_PAGES.TERMINATION' | translate }}</h3>
                      @if (systemSettings.tenantPages.enabled) {
                        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                          @for (termination of tenantTerminationFields; track termination) {
                            <section
                              class="astral-section-surface astral-section-surface--nested astral-form-stack astral-form-stack--relaxed"
                            >
                              <h4 class="astral-subsection-heading">{{ termination.caption | translate }}</h4>
                              <astral-input
                                [label]="'COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TERMINATION_FORM' | translate"
                                [value]="getYesNoText(getTenantPagesBoolean(termination.printProperty))"
                                [readonly]="true"
                                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.ALLOW_PRINT_TERMINATION_FORM_LABEL'"
                              ></astral-input>
                              <astral-input
                                [label]="'COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TERMINATION_ONLINE' | translate"
                                [value]="getYesNoText(getTenantPagesBoolean(termination.onlineProperty))"
                                [readonly]="true"
                                [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.ALLOW_ONLINE_TERMINATION'"
                              ></astral-input>
                            </section>
                          }
                        </astral-layout-group>
                      }
                      @if (readonlyTenantPagesOnlineTerminationEnabled) {
                        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                          <astral-input
                            [label]="'PROFILE_SETTINGS_FORM.ALLOWED_ONLINE_TERMINATION_SIGNATURE' | translate"
                            [value]="
                              getSelectionText(
                                onlineTerminationSignatureSelection,
                                systemSettings.tenantPages.allowedOnlineTerminationSignature
                              )
                            "
                            [readonly]="true"
                            [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.ALLOWED_ONLINE_TERMINATION_SIGNATURE'"
                          ></astral-input>
                          <astral-input
                            [label]="'PROFILE_SETTINGS_FORM.ONLINE_TERMINATION_EMAIL' | translate"
                            [value]="systemSettings.tenantPages.onlineTerminlationCallbackEmailAddresses"
                            [readonly]="true"
                            [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.TERMINATION_EMAIL'"
                          ></astral-input>
                        </astral-layout-group>
                      }
                    </section>
                    <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed astral-form-stack--display-summary">
                      <astral-input
                        [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_INVOICE_INFORMATION_REGISTRATION' | translate"
                        [value]="systemSettings.tenantPages.invoiceRegistrationMessage"
                        [readonly]="true"
                        [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.TENANT_PAGES_INVOICE_INFORMATION_REGISTRATION'"
                      ></astral-input>
                      <astral-input
                        [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_INVOICE_INFORMATION_REGISTRATION_ROW2' | translate"
                        [value]="systemSettings.tenantPages.invoiceRegistrationMessageRow2"
                        [readonly]="true"
                        [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.TENANT_PAGES_INVOICE_INFORMATION_REGISTRATION'"
                      ></astral-input>
                      <astral-input
                        [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_INVOICE_HAS_ACCOUNT_INFORMATION' | translate"
                        [value]="systemSettings.tenantPages.invoiceHasAccountMessage"
                        [readonly]="true"
                        [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.TENANT_PAGES_INVOICE_HAS_REGISTRATION'"
                      ></astral-input>
                      <astral-input
                        [label]="'PROFILE_SETTINGS_FORM.TENANT_PAGES_INVOICE_HAS_ACCOUNT_INFORMATION_ROW2' | translate"
                        [value]="systemSettings.tenantPages.invoiceHasAccountMessageRow2"
                        [readonly]="true"
                        [helpText]="'PROFILE_SETTINGS_FORM.HELP_TEXT.TENANT_PAGES_INVOICE_HAS_REGISTRATION'"
                      ></astral-input>
                    </section>
                  }
                  <div class="astral-form-actions astral-form-actions--start">
                    <astral-button
                      variant="secondary"
                      type="button"
                      labelKey="COMPANY.SYSTEM_SETTINGS_BULK.FIELD.TARGET"
                      (click)="openSystemSettingsSidebar('tenantPages')"
                    ></astral-button>
                  </div>
                </div>
              </astral-accordion>
            }
          </div>
        }
        @if (showOverviewSection) {
          <section>
            <astral-accordion [header]="'DASHBOARD.OVERVIEW_ITEM_HEADER'" (stateChanged)="onOverviewStateChanged($event)">
              <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1">
                @if (dwellingExist) {
                  <section class="astral-section-surface astral-stack-m">
                    <h5>{{ 'STATISTICS.DWELLING_HEADER' | translate }}</h5>
                    <app-residential-property-statistics [model]="dwelling"></app-residential-property-statistics>
                  </section>
                }
                @if (premisesExist) {
                  <section class="astral-section-surface astral-stack-m">
                    <h5>{{ 'STATISTICS.PREMISES_HEADER' | translate }}</h5>
                    <app-residential-property-statistics [model]="premises"></app-residential-property-statistics>
                  </section>
                }
                @if (parkingExist) {
                  <section class="astral-section-surface astral-stack-m">
                    <h5>{{ 'STATISTICS.PARKING_HEADER' | translate }}</h5>
                    <app-non-residential-property-statistics [model]="parking"></app-non-residential-property-statistics>
                  </section>
                }
                @if (otherRentalObjectExist) {
                  <section class="astral-section-surface astral-stack-m">
                    <h5>{{ 'STATISTICS.OTHER_RENTAL_OBJECT_HEADER' | translate }}</h5>
                    <app-non-residential-property-statistics [model]="otherRentalObject"></app-non-residential-property-statistics>
                  </section>
                }
              </astral-layout-group>
            </astral-accordion>
          </section>
        }
        @if (!dataContext.isNew) {
          <astral-accordion
            [helpText]="'TENANT.HELP_TEXT.DOCUMENT_LIST'"
            [header]="'DOCUMENT.LIST_HEADER'"
            (stateChanged)="documentComponent.loadDocuments()"
            [allowWidthExpansion]="true"
          >
            <app-company-document [company]="dataContext"></app-company-document>
          </astral-accordion>
        }
        @if (!isNew) {
          <astral-accordion [header]="'LOG.HEADER'" [allowWidthExpansion]="true" (stateChanged)="allowSectionInit('logs')">
            @if (isSectionAllowed('logs')) {
              <div class="astral-section-surface">
                <app-list-view
                  [columnDefinition]="logColumnDefinition"
                  [itemsSource]="logs"
                  [preferencesKey]="'company.logs'"
                ></app-list-view>
              </div>
            }
          </astral-accordion>
        }
        <app-sidebar [isOpen]="systemSettingsSidebarOpen" (close)="closeSystemSettingsSidebar()" [bigSize]="true">
          @if (systemSettingsForm) {
            <div class="form-content astral-sidebar-shell" [formGroup]="systemSettingsForm">
              <div class="form-body astral-sidebar-content astral-stack-l">
                <header>
                  <h2 class="astral-sidebar-heading">{{ systemSettingsSidebarTitleKey | translate }}</h2>
                </header>
                @if (systemSettingsSidebarSection === 'invoiceReminder') {
                  <section class="astral-section-surface astral-stack-m">
                    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
                      <astral-toggle [control]="getSystemSettingsControl('invoiceReminder.enabled')"></astral-toggle>
                      @if (getSystemSettingsControl('invoiceReminder.enabled')?.value) {
                        <astral-input
                          [control]="getSystemSettingsControl('invoiceReminder.remindAfterDays')"
                          [type]="'number'"
                        ></astral-input>
                      }
                    </astral-layout-group>
                    @if (getSystemSettingsControl('invoiceReminder.enabled')?.value) {
                      <app-information-block
                        mode="compact"
                        [text]="'COMPANY.SYSTEM_SETTINGS_BULK.HELP_TEXT.INVOICE_REMINDER_DELIVERY' | translate"
                      ></app-information-block>
                      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                        @for (field of reminderDeliveryMethodFields; track field) {
                          <astral-select
                            [control]="getSystemSettingsControl('invoiceReminder.' + field.property)"
                            [itemsSource]="reminderDeliveryMethodSelection"
                          ></astral-select>
                        }
                      </astral-layout-group>
                    }
                  </section>
                }
                @if (systemSettingsSidebarSection === 'automaticAdvicing') {
                  <section class="astral-section-surface astral-stack-m">
                    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
                      <astral-toggle [control]="getSystemSettingsControl('automaticAdvicing.enabled')"></astral-toggle>
                      @if (getSystemSettingsControl('automaticAdvicing.enabled')?.value) {
                        <astral-input
                          [control]="getSystemSettingsControl('automaticAdvicing.automaticAdvicingDayInMonth')"
                          [type]="'number'"
                        ></astral-input>
                      }
                    </astral-layout-group>
                  </section>
                }
                @if (systemSettingsSidebarSection === 'faultNotification') {
                  <section class="astral-section-surface astral-stack-m">
                    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                      <astral-toggle [control]="getSystemSettingsControl('faultNotification.enabled')"></astral-toggle>
                      @if (getSystemSettingsControl('faultNotification.enabled')?.value) {
                        <astral-toggle [control]="getSystemSettingsControl('faultNotification.sendLandlordNotification')"></astral-toggle>
                      }
                      @if (
                        getSystemSettingsControl('faultNotification.enabled')?.value &&
                        getSystemSettingsControl('faultNotification.sendLandlordNotification')?.value
                      ) {
                        <astral-input
                          class="astral-grid-full"
                          [control]="getSystemSettingsControl('faultNotification.faultNotificationReceivers')"
                        ></astral-input>
                      }
                    </astral-layout-group>
                  </section>
                }
                @if (systemSettingsSidebarSection === 'tenantPages') {
                  <section class="astral-stack-m">
                    <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed">
                      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                        <astral-toggle [control]="getSystemSettingsControl('tenantPages.enabled')"></astral-toggle>
                        @if (tenantPagesSettingsEnabled) {
                          <astral-select
                            [control]="getSystemSettingsControl('tenantPages.tenantPageSource')"
                            [itemsSource]="tenantPageSourceSelection"
                          ></astral-select>
                        }
                      </astral-layout-group>
                      @if (showExternalTenantPageSettings) {
                        <astral-input [control]="getSystemSettingsControl('tenantPages.tenantPageExternalUrl')"></astral-input>
                      }
                      @if (tenantPagesSettingsEnabled) {
                        <astral-toggle [control]="getSystemSettingsControl('tenantPages.displayDwellingInspection')"></astral-toggle>
                      }
                    </section>
                    @if (showBuiltInTenantPageSettings) {
                      <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed">
                        <h3 class="astral-section-heading">{{ 'COMPANY.SYSTEM_SETTINGS.TENANT_PAGES.TERMINATION' | translate }}</h3>
                        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
                          @for (termination of tenantTerminationFields; track termination) {
                            <section
                              class="astral-section-surface astral-section-surface--nested astral-form-stack astral-form-stack--relaxed"
                            >
                              <h4 class="astral-subsection-heading">{{ termination.caption | translate }}</h4>
                              <astral-toggle
                                [control]="getSystemSettingsControl('tenantPages.' + termination.printProperty)"
                              ></astral-toggle>
                              <astral-toggle
                                [control]="getSystemSettingsControl('tenantPages.' + termination.onlineProperty)"
                              ></astral-toggle>
                            </section>
                          }
                        </astral-layout-group>
                        @if (tenantPagesOnlineTerminationEnabled) {
                          <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1">
                            <astral-select
                              [control]="getSystemSettingsControl('tenantPages.allowedOnlineTerminationSignature')"
                              [itemsSource]="onlineTerminationSignatureSelection"
                            ></astral-select>
                            <astral-input
                              [control]="getSystemSettingsControl('tenantPages.onlineTerminlationCallbackEmailAddresses')"
                            ></astral-input>
                          </astral-layout-group>
                        }
                      </section>
                      <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed">
                        <astral-input [control]="getSystemSettingsControl('tenantPages.invoiceRegistrationMessage')"></astral-input>
                        <astral-input [control]="getSystemSettingsControl('tenantPages.invoiceRegistrationMessageRow2')"></astral-input>
                        <astral-input [control]="getSystemSettingsControl('tenantPages.invoiceHasAccountMessage')"></astral-input>
                        <astral-input [control]="getSystemSettingsControl('tenantPages.invoiceHasAccountMessageRow2')"></astral-input>
                      </section>
                    }
                  </section>
                }
                @if (systemSettingsSidebarSection === 'termination') {
                  <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed">
                    <h3 class="astral-section-heading astral-section-heading--subsection">
                      {{ 'COMPANY.SYSTEM_SETTINGS.TERMINATION.DIGITAL_SIGNING' | translate }}
                    </h3>
                    <astral-layout-group [columns]="2" [tabletColumns]="1" [mobileColumns]="1" [denseBooleanControls]="true">
                      <astral-toggle
                        [control]="getSystemSettingsControl('termination.useDigitalSigningWhenTerminatedByTenant')"
                      ></astral-toggle>
                      <astral-toggle
                        [control]="getSystemSettingsControl('termination.useDigitalSigningWhenTerminatedByLandlord')"
                      ></astral-toggle>
                      <astral-toggle
                        class="astral-grid-full"
                        [control]="getSystemSettingsControl('termination.requireSignatureBeforeTerminationWhenLandlordUsesDigitalSigning')"
                      ></astral-toggle>
                    </astral-layout-group>
                    <astral-textarea [control]="getSystemSettingsControl('termination.landlordMessage')" [rows]="5"></astral-textarea>
                  </section>
                }
                @if (systemSettingsSidebarSection === 'rent') {
                  <section class="astral-section-surface astral-stack-m">
                    <app-information-block [text]="'COMPANY.SYSTEM_SETTINGS.HELP_TEXT.PERIOD_RENT_ROUNDING'"></app-information-block>
                    <astral-toggle [control]="getSystemSettingsControl('rent.roundPeriodRent')"></astral-toggle>
                  </section>
                }
                @if (systemSettingsSidebarSection === 'externalAccountsReceivable') {
                  <section class="astral-section-surface astral-stack-m">
                    <app-information-block [text]="'COMPANY.EXTERNAL_ACCOUNTS_RECEIVABLE.DESCRIPTION' | translate"></app-information-block>
                    <astral-toggle [control]="getSystemSettingsControl('externalAccountsReceivable.enabled')"></astral-toggle>
                  </section>
                }
              </div>
              <footer class="form-footer astral-sidebar-footer">
                <astral-button variant="primary" type="button" labelKey="SAVE_BTN" (click)="saveSystemSettings()"></astral-button>
                <astral-button
                  variant="secondary"
                  type="button"
                  labelKey="CANCEL_BTN"
                  (click)="closeSystemSettingsSidebar()"
                ></astral-button>
              </footer>
            </div>
          }
        </app-sidebar>
        <app-sidebar
          [isOpen]="avyIntegrationSidebarOpen"
          [showDefaultHeader]="!avyIntegrationSavePending"
          (close)="requestCloseAvyIntegrationSidebar()"
          [bigSize]="true"
        >
          @if (avyIntegrationForm) {
            <div class="form-content astral-sidebar-shell" [formGroup]="avyIntegrationForm">
              <div class="form-body astral-sidebar-content astral-stack-l">
                <header>
                  <h2 class="astral-sidebar-heading">{{ 'COMPANY.INTEGRATION.AVY_TENANT_APP' | translate }}</h2>
                </header>
                <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed">
                  <astral-toggle [control]="avyIntegrationForm.controls['enabled']"></astral-toggle>
                  @if (avyIntegrationEnabled) {
                    <astral-input type="password" [control]="avyIntegrationForm.controls['apiKey']"></astral-input>
                    <astral-toggle
                      [control]="avyIntegrationForm.controls['sendPushNotificationsOnFaultNotificationUpdates']"
                    ></astral-toggle>
                  }
                </section>
              </div>
              <footer class="form-footer astral-sidebar-footer">
                <astral-button
                  variant="primary"
                  type="button"
                  labelKey="SAVE_BTN"
                  [disabled]="avyIntegrationSavePending"
                  (click)="saveAvyIntegration()"
                ></astral-button>
                <astral-button
                  variant="secondary"
                  type="button"
                  labelKey="CANCEL_BTN"
                  [disabled]="avyIntegrationSavePending"
                  (click)="requestCloseAvyIntegrationSidebar()"
                ></astral-button>
              </footer>
            </div>
          }
        </app-sidebar>
      </div>
    </form>
  }
</section>

@if (!isNew) {
  <app-company-account-plan-change
    [company]="dataContext"
    [open]="accountPlanSidebarOpen"
    (saved)="onAccountPlanChanged($event)"
    (cancelled)="closeAccountPlanSidebar()"
  ></app-company-account-plan-change>
}
